import dayjs from "dayjs";
import { DEFAULT_DATE_FORMAT } from "../constants";
import i18n from "../i18n";

class Utils {
  static parseDateStringWithMoment(dateString: string): Date | null {
    // Attempt to parse the date string using the specified format
    const parsedDate = dayjs(
      dateString,
      DEFAULT_DATE_FORMAT + " hh:mm A",
      true,
    );

    // Check if the parsing was successful
    if (!parsedDate.isValid()) {
      console.error("Invalid date string format:", dateString);
      return null;
    }

    // Convert the moment object to a native Date object
    return parsedDate.toDate();
  }
  static convertDuration = (duration: number): string => {
    const day = Math.floor(duration / 24);
    if (day === 0) {
      return `${duration} ${duration > 1 ? "hours" : "hour"}`;
    }
    return `${day} ${day > 1 ? "days" : "day"}`;
  };

  static getCurrentLanguage = (): string => {
    return i18n.language;
  };
  static formatDate = (date?: Date | number, format?: string): string => {
    if (!date) {
      return "";
    }
    return dayjs(date).format(format || DEFAULT_DATE_FORMAT);
  };
  static remToPx = (rem: number): number => {
    const rootFontSize = parseFloat(
      getComputedStyle(document.documentElement).fontSize,
    );
    return rem * rootFontSize;
  };

  static createMarkup = (html?: string) => ({ __html: html || "" });
  static adjustPosition = (element: HTMLElement) => {
    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    if (rect.right + 30 > viewportWidth) {
      element.style.left = "auto";
      element.style.right = "0";
    } else if (rect.left < 0) {
      element.style.left = "0";
      element.style.right = "auto";
    } else {
      element.style.left = "0";
      element.style.right = "auto";
    }
  };
  // static createOptionsKKK(
  //   variants: Variant[],
  //   attributeType: string,
  //   filterFn?: (variant: Variant) => boolean,
  //   selectedValue?: string,
  //   clearSelection?: () => void
  // ): OptionProps[] {
  //   const uniqueValues = new Set<string>();

  //   // Collect all unique options
  //   const options: OptionProps[] =
  //     variants?.reduce<OptionProps[]>((acc, variant) => {
  //       const matchingAttributes = variant.attributesKKK?.filter(
  //         (attr) => attr.attributeType === attributeType
  //       );

  //       matchingAttributes?.forEach((attr) => {
  //         const value = attr.value || "";
  //         const displayName = attr.name || value;

  //         if (!uniqueValues.has(value)) {
  //           uniqueValues.add(value);
  //           acc.push({ displayName, value, disabled: true });
  //         }
  //       });

  //       return acc;
  //     }, []) ?? [];

  //   // Filter active options based on the provided filter function
  //   const activeVariants = variants?.filter((variant) =>
  //     filterFn ? filterFn(variant) : true
  //   );

  //   // Update the disabled state of each option
  //   options.forEach((option) => {
  //     option.disabled = !activeVariants?.some((variant) =>
  //       variant.attributesKKK?.some(
  //         (attr) =>
  //           attr.attributeType === attributeType && attr.value === option.value
  //       )
  //     );
  //   });

  //   // Clear selection if the selected value is disabled or not present
  //   const isSelectedValueValid = options.some(
  //     (option) => option.value === selectedValue && !option.disabled
  //   );
  //   if (selectedValue && !isSelectedValueValid) {
  //     clearSelection?.();
  //   }

  //   return options;
  // }
  static add(...values: (number | null | undefined)[]): number {
    return values.reduce((sum, value) => (sum ?? 0) + (value ?? 0), 0) || 0;
  }
  static formatDateTime(date?: string, time?: string): number | undefined {
    if (!date) return undefined;
    const formattedDate = dayjs(date).format("MM/DD/YYYY");

    // Normalize time string to ensure it has two digits for hour and minute
    const normalizedTime = (time?.trim() || "00:00 AM").replace(
      /^(\d{1,2}):(\d{1,2})\s*([apAP][mM])?$/,
      (match, hour, minute, ampm) => {
        const formattedHour = String(parseInt(hour, 10)).padStart(2, "0");
        const formattedMinute = String(parseInt(minute, 10)).padStart(2, "0");
        return `${formattedHour}:${formattedMinute} ${
          ampm ? ampm.toUpperCase() : "AM"
        }`;
      },
    );
    // Combine formatted date and normalized time
    const dateTimeString = `${formattedDate} ${normalizedTime}`;
    // Attempt to parse the combined string with moment
    const dateTimeMoment = dayjs(dateTimeString, "MM/DD/YYYY HH:mm A");
    // Check if parsing was successful
    if (dateTimeMoment.isValid()) {
      return dateTimeMoment.valueOf();
    } else {
      console.error("Invalid date or time format");
      return undefined;
    }
  }

  // static mapBookingInfoToBookingInfoRequest = (
  //   bookingInfo?: BookingInfo
  // ): BookingInfoRequest => {
  //   let prioritiesMap: any;
  //   if (bookingInfo?.priorities) {
  //     prioritiesMap = bookingInfo.priorities.map((priority) => {
  //       return {
  //         date: priority.date,
  //         timeSlot: Number(priority.timeSlots?.id),
  //         dateTime: this.formatDateTime(
  //           priority.date,
  //           priority?.timeSlots?.value || "00:00 AM"
  //         ),
  //       };
  //     });
  //   }
  //   return {
  //     productId: bookingInfo?.productId,
  //     qtyAdult: bookingInfo?.qtyAdult,
  //     qtyChild: bookingInfo?.qtyChild,
  //     voucherCode: bookingInfo?.voucher?.code,
  //     qtyRoom: bookingInfo?.qtyRoom,
  //     qtySim: bookingInfo?.qtySim,
  //     qtyVehicle: bookingInfo?.qtyVehicle,
  //     ageNumbers: bookingInfo?.ageNumbers,
  //     additional: bookingInfo?.additional?.id,
  //     luggage: bookingInfo?.luggage?.id,
  //     pickUpAirport: bookingInfo?.pickUpAirport?.id,
  //     priorities: prioritiesMap || undefined,
  //     ticketType: bookingInfo?.ticketType?.id,
  //     seat: bookingInfo?.seat?.id,
  //     selectDateNow: bookingInfo?.selectDateNow,
  //     products: bookingInfo?.products?.map((product) =>
  //       this.mapBookingInfoToBookingInfoRequest(product)
  //     ),
  //     dataPackage: bookingInfo?.dataPackage?.id,
  //     simValidity: bookingInfo?.simValidity?.id,
  //     dropOffLocation: bookingInfo?.dropOffLocation,
  //   };
  // };

  static formatKoreanDateTime(inputDate?: string | Date): string | "" {
    return dayjs(inputDate, "YYYY-MM-DD HH:mm:ss").format(
      "YYYY년 M월 D일 HH:mm",
    );
  }

  // static mapCartResponseToCartItem(cartResponse: CartResponse): CartItem {
  //   return {
  //     itemId: uuidv4(), // Generate unique item ID
  //     productType: cartResponse.product?.productType ?? "",
  //     status: undefined, // Status can be added if applicable
  //     bookingInfo: {
  //       id: undefined,
  //       productId: cartResponse.productId,
  //       qtyAdult: cartResponse.qtyAdult,
  //       qtyChild: cartResponse.qtyChild,
  //       qtyRoom: cartResponse.qtyRoom,
  //       qtyVehicle: cartResponse.qtyVehicle,
  //       qtySim: cartResponse.qtySim ?? 0,
  //       ageNumbers: cartResponse.ageNumbersList ?? [],
  //       additional: cartResponse.productAttribute?.find(
  //         (attr) => attr.type === "ADDITIONAL"
  //       )?.value,
  //       luggage: cartResponse.productAttribute?.find(
  //         (attr) => attr.type === "LUGGAGE"
  //       )?.value,
  //       pickUpAirport: cartResponse.productAttribute?.find(
  //         (attr) => attr.type === "PICK_UP_AIRPORT"
  //       )?.value,
  //       ticketType: cartResponse.ticketType,
  //       priorities: [
  //         cartResponse.priority1,
  //         cartResponse.priority2,
  //         cartResponse.priority3,
  //       ]
  //         .filter((priority) => priority !== undefined)
  //         .map((priority) => ({
  //           date: priority?.toString(),
  //           dateTime: priority,
  //         })),
  //       productInfo: {
  //         name: cartResponse.product?.name ?? "",
  //         thumbnail: cartResponse.product?.thumbnail ?? "",
  //         productType: cartResponse.product?.productType ?? "",
  //         priceList: cartResponse.prices ?? [],
  //         attributeList: cartResponse.productAttribute ?? [],
  //       },
  //       selectDate: cartResponse.selectDate === "yes",
  //       cartItemId: cartResponse.id,
  //     },
  //   };
  // }
  // static mapCartItemToBookingInfoRequest = (
  //   cartItem: CartItem
  // ): BookingInfoResquest => {
  //   if (!cartItem.bookingInfo) {
  //     throw new Error("Invalid CartItem: Missing bookingInfo");
  //   }
  //   return {
  //     cartItemId: !Number.isNaN(Number(cartItem.bookingInfo?.cartItemId))
  //       ? Number(cartItem.bookingInfo?.cartItemId)
  //       : undefined, //if source is number then use that, else undefined
  //     productId: cartItem.bookingInfo?.productId ?? 0,
  //     qtyAdult: cartItem.bookingInfo?.qtyAdult ?? 0,
  //     qtyChild: cartItem.bookingInfo?.qtyChild ?? 0,
  //     qtyRoom: cartItem.bookingInfo?.qtyRoom ?? 0,
  //     qtyVehicle: cartItem.bookingInfo?.qtyVehicle ?? 0,
  //     qtySim: cartItem.bookingInfo?.qtySim ?? 0,
  //     ageNumbers: cartItem.bookingInfo?.ageNumbers ?? [],
  //     additional: cartItem.bookingInfo?.additional ?? 0,
  //     luggage: cartItem.bookingInfo?.luggage ?? 0,
  //     pickUpAirport: cartItem.bookingInfo?.pickUpAirport ?? 0,
  //     priorities:
  //       cartItem.bookingInfo?.priorities?.map((priority) => ({
  //         date: priority.date ?? "",
  //         timeSlots: priority.timeSlots ?? "",
  //         dateTime: priority.dateTime ?? 0,
  //       })) ?? [],
  //     ticketType: cartItem.bookingInfo?.ticketType?.id ?? 0,
  //     selectDate: cartItem.bookingInfo?.selectDate ?? false,
  //   };
  // };
}
export default Utils;

export const isValidEmail = (email?: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email ?? "");
};

export const hashStr = (str: string): number => {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32-bit integer
  }
  return hash;
};
